export const ASSET_CASE_TYPE_MAP: Record<string, string> = {
  investment: "Unit-linked",
  shares: "Shares",
  "home-personal": "Home/Personal",
  "bank-societies": "Banks/B Societies",
};

export const ASSET_CASE_TYPE_REVERSE_MAP: Record<string, string> = {
  "Unit-linked": "investment",
  "Shares": "shares",
  "Home/Personal": "home-personal",
  "Banks/B Societies": "bank-societies",
};

export const ASSET_HAS_STATUS_FIELD: Record<string, boolean> = {
  investment: true,
  shares: true,
  "home-personal": false,
  "bank-societies": true,
};

export const ASSET_CONTEXT_MAP: Record<string, string> = {
  investment: "ASSET_INVESTMENT_ASSET",
  shares: "ASSET_SHAREHOLDINGS_ASSET",
  "home-personal": "ASSET_HOME_AND_PERSONAL_ASSET",
  "bank-societies": "ASSET_BANK_OR_BUILDING_SOCIETIES_ASSET",
};

export const ASSET_LABEL_MAP: Record<string, string> = {
  investment: "Investment",
  shares: "Share Holdings",
  "home-personal": "Home & Personal",
  "bank-societies": "Bank / Building Soc.",
};

export const DEFAULT_SUB_TYPE = "investment";
